export default {
  list: '/v3/recruit/menu/list',
  cancelChangeCity: '/v3/recruit/cancelChangeCity',
  courierAge: '/v3/recruit/courierAge', // 查询年龄
  detail: '/v3/recruit/equipment/payment/detail'
}
